import BlendedSectorWeightings from "@/components/benchmark/BlendedSectorWeightings";

const PORTFOLIOS = [1, 2, 3, 4, 5] as const;

export default function PSectorWeightings() {
  return (
    <BlendedSectorWeightings
      side="p"
      portfolios={PORTFOLIOS}
      title="P Sector Weightings"
      portfolioLabel={(p) => `P${p}`}
      policyRange="P"
    />
  );
}
